var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYahoo = function SvgYahoo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3h5.104l2.972 7.604L15.086 3h4.97l-7.483 18H7.572l2.048-4.77z"
  })));
};
export default SvgYahoo;